import React, { useContext, useEffect } from 'react';
import NavBar from '../components/NavBar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import Testimonials from '../components/HomeTestimonials';
import HomeWebinar from '../components/HomeWebinar';
import HomeBlog from '../components/HomeBlog';
import { HeaderContext } from '../context/HeaderContext';
import StatsSection from '../components/StatsSection';
import FeaturedCourses from '../components/FeaturedCourses';
import CallToAction from '../components/CallToAction';
import HomeMemberships from '../components/HomeMemberships';
import { PixelContext } from './Context/PixelContext';
import { initFacebookPixel } from '../pixel';

const Home = () => {
  const { loading } = useContext(HeaderContext);

  const { pixel } = useContext(PixelContext);
  const pixelId = pixel?.pixel_id || null;

    useEffect(() => {
      if (pixelId) {
        initFacebookPixel(pixelId);
      }
    }, [pixelId]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="w-16 h-16 border-4 border-green-500 border-t-transparent border-solid rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="font-sans bg-white">
      <NavBar />
      <main>
        <Hero />
        <StatsSection />
        <HomeWebinar />
        <HomeMemberships />
        <HomeBlog />
        <Testimonials />
        {/* <CallToAction /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Home;